import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer } from 'recharts';

//
// @Nick
// This is not supposed to be any. help me. Im realy bad at typescripting
//

export function VonGraph({ soleProprietorshipCost, corporationCost, title_venn, title_emz }: any) {

    return (
        <div className='vongraph'>

            <h2 style={{ 'top': '48px' }}>{ title_emz }</h2>
            <p style={{ 'top': '70px' }}>€ { Math.round( soleProprietorshipCost * 100 ) / 100 }</p>
            <h2 style={{ 'top': '148px' }}>{ title_venn }</h2>
            <p style={{ 'top': '170px' }}>€ { Math.round( corporationCost * 100 ) / 100 }</p>

            <BarChart
                width={400}
                height={200}
                layout="vertical"
                barGap={70}
                data={[
                    {
                        name: '',
                        soleProprietorship: soleProprietorshipCost,
                        corporation: corporationCost,
                    },
                ]}
                margin={{
                    top: -20,
                    right: 0,
                    left: 8,
                    bottom: 0,
                }}
            >
                <XAxis type="number" hide={true} />
                <YAxis type="category" dataKey=" " hide={true} />
                <Bar type="monotone" dataKey="soleProprietorship" fill="#d0d1d2" barSize={32} radius={[0, 8, 8, 0]} />
                <Bar type="monotone" dataKey="corporation" fill="var(--primary-color)" barSize={32} radius={[0, 8, 8, 0]} />
            </BarChart>
        </div>
    )
}